<!-- Wraps a single chat event to report its visibility to the enclosing ChatEventContainer. -->

<script lang="ts" setup generic="T extends { seq: number }">
import { injectContext } from '@nzyme/vue-utils/context.js';
import { getCurrentInstance, nextTick, onBeforeUnmount, onMounted } from 'vue';

import { ChatEventContainerContext } from './ChatEventContainerContext.js';

defineProps<{ event: T }>();

const instance = getCurrentInstance();
const context = injectContext(ChatEventContainerContext, { optional: true });

if (context) {
  onMounted(async () => {
    await nextTick();
    context.observe(instance?.proxy);
  });

  onBeforeUnmount(() => {
    context.unobserve(instance?.proxy);
  });
}
</script>

<template>
  <div :data-seq="event.seq">
    <slot />
  </div>
</template>
